import { render, staticRenderFns } from "./tea.vue?vue&type=template&id=69eca268&scoped=true"
import script from "./tea.vue?vue&type=script&lang=js"
export * from "./tea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eca268",
  null
  
)

export default component.exports